import { Directive, inject, OnInit } from '@angular/core';
import { ListService, TrackByService } from '@abp/ng.core';
import { Router } from '@angular/router';
import { PaymentHistoryViewService } from 'src/app/payments/services/payment-history.service';
import { GetTransactionsListResponse, TransactionStatus } from '@proxy/payments';

export const ChildTabDependencies = [];

export const ChildComponentDependencies = [];

@Directive({ standalone: true })
export abstract class AbstractPaymentHistoryComponent implements OnInit {
  public readonly list = inject(ListService);
  public readonly track = inject(TrackByService);
  public readonly service = inject(PaymentHistoryViewService);
  public readonly router = inject(Router);

  protected title = '::RequestedClaims';

  public maxResultCount = 10;
  public sorting = '';

  ngOnInit() {
    this.getPaymentHistory();
  }

  getPaymentHistory() {
    // No detectChanges() callback: service.data is a signal, so the table redraws itself (#42).
    this.service.hookToUserQuery(() => {}, this.maxResultCount, this.sorting);
  }

  downloadInvoce(record: GetTransactionsListResponse) {
    this.service.downloadInvoice(record.transaction.id?.toString());
  }

  // Pending is a real, visible state: a transaction is created before the customer is sent to the
  // gateway, so an abandoned checkout leaves one behind indefinitely. It used to fall through to
  // 'Fail', which told the customer a payment had failed when it had simply never concluded.
  public getClaimStatusName(status: TransactionStatus): string {
    if (status === TransactionStatus.Paid) {
      return '::Paid';
    }
    return status === TransactionStatus.Pending ? '::Pending' : '::Fail';
  }

  getStatusClass(status: TransactionStatus): string {
    if (status === TransactionStatus.Paid) {
      return 'paid';
    }
    return status === TransactionStatus.Pending ? 'pending' : 'fail';
  }
}
